export const GET_USER_DATA = 'GET_USER_DATA';
export const UPDATE_USER_PERSONAL = 'UPDATE_USER_PERSONAL';
export const CHECK_USER_PASSWORD = 'CHECK_USER_PASSWORD';
export const UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL';
export const UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD';
export const UPDATE_USER_AVATAR = 'UPDATE_USER_AVATAR';
export const REMOVE_USER_AVATAR = 'REMOVE_USER_AVATAR';
export const GET_EMAILS_PEOPLE = 'GET_EMAILS_PEOPLE';